import { Scale } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../shared/ui/Button.js';
import { Card } from '../../shared/ui/Card.js';
import { useComparisons } from '../../shared/api/queries.js';
import { DeltaTile } from './ComparisonSummary.js';
import { effectSentence, formatDay } from './comparison-format.js';
import './comparison.css';

/** The dashboard's window on the latest publication: its measured effect, and the way to the full view. */
export function ComparisonSummaryCard({ projectId }: { projectId: string | undefined }) {
  const navigate = useNavigate();
  const { data } = useComparisons(projectId);
  const latest = data?.items[0];
  const guidanceCount = latest?.guidances.length ?? 0;

  return (
    <Card
      title={
        latest
          ? `Effet de la dernière publication · version ${latest.releaseVersion}`
          : 'Effet de la dernière publication'
      }
      icon={<Scale size={15} />}
      className="dash__section"
      actions={
        <Button variant="ghost" onClick={() => navigate('/comparison')} data-testid="open-comparison">
          Voir la comparaison
        </Button>
      }
    >
      {latest ? (
        <>
          <p className="comparison__reading">{effectSentence(latest)}</p>
          <div className="comparison__tiles" data-testid="dashboard-comparison">
            <DeltaTile delta={latest.completionRate} />
            <DeltaTile delta={latest.frictionScore} />
          </div>
          <p className="comparison__rule">
            {latest.days} jours avant ({formatDay(latest.before.from)} → {formatDay(latest.before.to)}) contre{' '}
            {latest.days} jours après ({formatDay(latest.after.from)} → {formatDay(latest.after.to)}) ·{' '}
            {guidanceCount} guidance{guidanceCount > 1 ? 's' : ''} publiée{guidanceCount > 1 ? 's' : ''} dans
            cette version.
          </p>
        </>
      ) : !data ? (
        <p className="comparison__rule">Chargement de la comparaison…</p>
      ) : (
        <p className="comparison__rule" data-testid="dashboard-comparison-empty">
          {data?.activeReleaseVersion
            ? "Une version est en ligne ; la comparaison s'ouvrira dès que des sessions auront été mesurées sous cette version."
            : "Aucune publication mesurée avant et après pour l'instant : publiez une guidance, puis laissez la mesure se poursuivre."}
        </p>
      )}
    </Card>
  );
}
